import { FC } from 'react';
import { useOpenOrCloseExistingCase } from 'v2/modules/withRunForm/hooks/useIntent/useOpenOrCloseExistingCase';
import TargetSelector from './TargetSelector';
import IntentTypeSelector from '../IntentTypeSelector';
import { Intent } from 'v3/quantConfig/types/intent.type';

type OpenOrCloseExistingCaseProps = {
  intent: Intent;
  renderDeleteBtn?: React.ReactElement | null;
};

const OpenOrCloseExistingCase:FC<OpenOrCloseExistingCaseProps> = ({ intent, renderDeleteBtn }) => {
  const intentConfigs = useOpenOrCloseExistingCase(intent);

  return (
    <div className="transaction_details body">
      <IntentTypeSelector
        isAdjustmentIntent
        isAdvancedMode={intentConfigs.isAdvancedMode}
        isIdle={intent.isIdle}
        value={intent.type}
        onChange={intentConfigs.onChangeIntentType}
      />
      <div className="transaction_details-items transction-instruments">
        <TargetSelector
          target={intentConfigs?.caseIndex || ''}
          onChangeChangeIndex={intentConfigs.onChangeCaseIndex}
        />
      </div>
      {renderDeleteBtn && renderDeleteBtn}
    </div>
  );
};

export default OpenOrCloseExistingCase;
